import { createTRPCClient, httpBatchLink } from "@trpc/client";
import type { TRPCClient } from "@trpc/client";
import { createTRPCContext } from "@trpc/tanstack-react-query";
import superjson from "superjson";
import type { PublicRouter } from "@ec2/contracts";

export type ApiClient = TRPCClient<PublicRouter>;

export interface CreateApiClientOptions {
  /** API origin; "" for same-origin. */
  baseUrl?: string;
  /** Injectable for tests (in-process Hono app) — defaults to global fetch. */
  fetch?: typeof fetch;
}

/**
 * The app's tRPC client over the public router contract.
 * superjson transformer is REQUIRED (see packages/contracts/test/client.test-d.ts).
 */
export function createApiClient(opts: CreateApiClientOptions = {}): ApiClient {
  const base = opts.baseUrl ?? "";
  return createTRPCClient<PublicRouter>({
    links: [
      httpBatchLink({
        url: `${base.replace(/\/$/, "")}/trpc`,
        transformer: superjson,
        fetch: opts.fetch
          ? (input, init) => opts.fetch!(input, init as RequestInit)
          : (input, init) => fetch(input, { ...(init as RequestInit), credentials: "include" }),
      }),
    ],
  });
}

/** React context/provider/hook for tRPC query options (TanStack Query v5 style). */
export const { TRPCProvider, useTRPC } = createTRPCContext<PublicRouter>();
